import { Flex } from 'antd';
import { RequestListContext } from '@Components/types/RequestListContext';
import { NoData } from '@Components/RequestList/noData';
import { TenderSupplier } from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';
import Card from './components/Card';
import { MaterialVendorItem } from '../../../types';

import styles from './request-list-mobile.module.css';

export interface VendorListMobileProps {
  materialVendorItem: MaterialVendorItem;
  context?: RequestListContext;
  handleShowVendorDetails: (vendor: TenderSupplier) => void;
}

const VendorListMobile = ({
  materialVendorItem,
  context = 'my-requests',
  handleShowVendorDetails,
}: VendorListMobileProps): JSX.Element | null => {
  if (!materialVendorItem) {
    return <NoData context={context} />;
  }

  const bestAmount = materialVendorItem?.vendors.reduce((acc, curr) => {
    return Math.min(acc, Number(curr.vendorItem.amount));
  }, Infinity);

  return (
    <div className={styles.requestListMobile}>
      <Flex vertical style={{ marginBottom: '16px' }}>
        <div className={styles.vendorsInfo}>
          <span className={styles.vendorsLength}> Vendors </span>(
          {materialVendorItem?.vendors.length})
        </div>
        <div>Select one or more vendors.</div>
      </Flex>
      {materialVendorItem?.vendors?.map((vendor) => {
        const { title, vendorItem } = vendor;
        const { amount, available, brand, rate, vendorId } = vendorItem;
        const tenderSupplier = {
          id: vendorItem.vendorId,
          name: title,
        } as TenderSupplier;

        return (
          <Card
            key={vendorId}
            vendorName={title}
            amount={amount}
            available={available}
            brand={brand}
            rate={rate}
            isBest={bestAmount === Number(amount)}
            handleShowVendorDetails={() =>
              handleShowVendorDetails(tenderSupplier)
            }
          />
        );
      })}
    </div>
  );
};

export default VendorListMobile;
